import { makeStyles } from '../styles';
export const useStyles = makeStyles(({ palette, spacing }) => ({
    iconLinkRoot: {
        margin: spacing(),
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    button: {
        cursor: 'pointer',
        width: '100%',
        border: `1px solid ${palette.grey.light}`,
        borderRadius: 4,
        background: palette.background.default,
        boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.16)',
        WebkitBoxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.16)',
        MozBoxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.16)',
        padding: spacing(0.5),
        '&:hover, &:focus': {
            border: `1px solid ${palette.secondary.main}`,
        },
        '&:disabled': {
            cursor: 'default',
            border: `1px solid ${palette.grey.light} !important`,
        },
    },
    selected: {
        color: palette.secondary.main,
        background: palette.secondary.main,
        border: `1px solid ${palette.secondary.main}`,
    },
    icon: {
        color: palette.secondary.main,
        fill: palette.secondary.main,
        height: '100%',
        width: '100%',
    },
    iconWrapper: {
        position: 'relative',
        flexGrow: 1,
    },
    disabledIcon: {
        cursor: 'default',
        opacity: 0.2,
        color: palette.text.minor,
    },
    selectedIcon: {
        color: palette.text.light,
        fill: palette.text.light,
    },
    large: {
        width: 80,
        minHeight: 80,
        minWidth: 80,
        maxHeight: 80,
        maxWidth: 80,
    },
    xl: {
        width: 176,
        minHeight: 176,
        minWidth: 176,
        maxHeight: 176,
        maxWidth: 176,
    },
    text: {
        padding: spacing(1, 0),
    },
    disabledText: {
        color: palette.text.minor,
    },
    selectedText: {
        color: palette.secondary.main,
    },
    loaderContainer: {
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        borderRadius: 4,
    },
}));
//# sourceMappingURL=iconLink.styles.js.map